import { Injectable } from '@angular/core';
import { GeoJson, MARKERS } from './map';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import 'rxjs/add/operator/map';

@Injectable()
export class GeojsonService {

	accessToken:string;
	apiUrl:string;

  constructor( private http: HttpClient) {
		this.accessToken = '1245c38775ff9fd8b8a721e4fe7472ab5d06020f853f66c516f26eb96fb87235'
		this.apiUrl = 'http://ca.ecouterlemonde.net/service.php/find/ca_objects'
	}

	getData() {
		const data = {
			"bundles" : {
				"access" : { "convertCodesToDisplayText" : true },
				"status" : { "convertCodesToDisplayText" : true },
				"ca_entities.entity_id" : {"returnAsArray" : true }
			}
		}

		const params = new HttpParams()
			.set('authToken',this.accessToken)
			.set('q','*')
			.set('source',encodeURIComponent(JSON.stringify(data)))
		/*this.http.get(this.apiUrl, { params: params } )
			.subscribe( resp=> {
				console.log('.... data ...');
				console.log(resp);
			});*/
		return of();
	}

}



// WEBPACK FOOTER //
// ./src/app/geojson.service.ts